import { useEffect, useRef, useState } from 'react';

const SCROLL_ROOT_SELECTOR = '.ots-container';
const COMPACT_ENTER = 80;
const COMPACT_EXIT = 20;

export function useScrollCompact() {
  const [isCompact, setIsCompact] = useState(false);
  const compactRef = useRef(false);
  const frameRef = useRef(null);

  useEffect(() => {
    const root = document.querySelector(SCROLL_ROOT_SELECTOR);
    if (!root) return undefined;

    const update = () => {
      frameRef.current = null;
      const scrollTop = root.scrollTop;

      if (!compactRef.current && scrollTop > COMPACT_ENTER) {
        compactRef.current = true;
        setIsCompact(true);
        return;
      }

      if (compactRef.current && scrollTop < COMPACT_EXIT) {
        compactRef.current = false;
        setIsCompact(false);
      }
    };

    const onScroll = () => {
      if (frameRef.current !== null) return;
      frameRef.current = window.requestAnimationFrame(update);
    };

    update();
    root.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      root.removeEventListener('scroll', onScroll);
      if (frameRef.current !== null) {
        window.cancelAnimationFrame(frameRef.current);
      }
    };
  }, []);

  return isCompact;
}
